var _a, _b;
import { __assign, __spreadArrays } from "tslib";
import { Plugins, PluginToolbarButtons } from '../enums';
import { emotePluginCreator } from './emote';
import { galleryPluginCreator } from './plugin-gallery';
import { videoPluginCreator } from './plugin-video';
import { imagePluginCreator } from './plugin-image/createImagePlugin';
import { createGiphyPlugin } from 'wix-rich-content-plugin-giphy';
import { createHashtagPlugin } from 'wix-rich-content-plugin-hashtag';
import { createLinkPlugin } from 'wix-rich-content-plugin-link';
import { createLinkPreviewPlugin } from 'wix-rich-content-plugin-link-preview';
import { createIndentPlugin } from 'wix-rich-content-plugin-indent';
import { scrollerPluginCreator } from './scroller/createScrollerPlugin';
import { dndUploadPluginCreator } from './plugin-dnd-upload';
import { createTextColorPlugin, ModalsMap as TextColorModalsMap, } from 'wix-rich-content-plugin-text-color';
import { externalMentionPluginCreator } from './mention';
import { ModalsMap as VideoModalsMap } from './plugin-video/modals';
import { ModalsMap as ImageModalsMap } from './plugin-image/modals';
import { ModalsMap as GalleryModalsMap } from './plugin-gallery/modals';
var configurablePlugins = (_a = {},
    // Factoried plugins, these are older and bootstrap their config and return creator function (CreatePluginFunction)
    _a[Plugins.EMOTES] = emotePluginCreator,
    _a[Plugins.IMAGE] = imagePluginCreator,
    _a[Plugins.GALLERY] = galleryPluginCreator,
    _a[Plugins.VIDEO] = videoPluginCreator,
    _a[Plugins.MENTION] = externalMentionPluginCreator,
    _a[Plugins.SCROLLER] = scrollerPluginCreator,
    // Creator functions, normal plugins that just return CreatePluginFunction so the bootstrap below works
    _a[Plugins.LINK] = function () { return createLinkPlugin; },
    _a[Plugins.LINK_PREVIEW] = function () { return createLinkPreviewPlugin; },
    _a[Plugins.HASHTAG] = function () { return createHashtagPlugin; },
    _a[Plugins.GIPHY] = function () { return createGiphyPlugin; },
    _a[Plugins.INDENT] = function () { return createIndentPlugin; },
    _a[Plugins.SCROLLER] = scrollerPluginCreator,
    _a[Plugins.DND_UPLOAD] = dndUploadPluginCreator,
    _a[Plugins.TEXT_COLOR] = function () { return createTextColorPlugin; },
    _a);
var defaultPluginsConfig = (_b = {},
    _b[Plugins.IMAGE] = {
        toolbar: [
            PluginToolbarButtons.BEST_FIT,
            PluginToolbarButtons.FULL_WIDTH,
            PluginToolbarButtons.ALIGN_LEFT,
            PluginToolbarButtons.ALIGN_RIGHT,
            PluginToolbarButtons.SEPARATOR,
            PluginToolbarButtons.LINK,
            PluginToolbarButtons.SEPARATOR,
            PluginToolbarButtons.REPLACE,
            PluginToolbarButtons.DELETE,
        ],
    },
    _b[Plugins.GALLERY] = {
        toolbar: [
            PluginToolbarButtons.BEST_FIT,
            PluginToolbarButtons.FULL_WIDTH,
            PluginToolbarButtons.LAYOUT_GRID,
            PluginToolbarButtons.LAYOUT_MASONRY,
            PluginToolbarButtons.SEPARATOR,
            PluginToolbarButtons.REPLACE,
            PluginToolbarButtons.DELETE,
        ],
    },
    _b[Plugins.VIDEO] = {},
    _b[Plugins.EMOTES] = {},
    _b[Plugins.MENTION] = {},
    _b[Plugins.LINK] = {},
    _b[Plugins.GIPHY] = {},
    _b[Plugins.HASHTAG] = {},
    _b[Plugins.INDENT] = {},
    _b[Plugins.SCROLLER] = {},
    _b[Plugins.DND_UPLOAD] = {},
    _b[Plugins.LINK_PREVIEW] = {},
    _b);
export var modalsMap = __assign(__assign(__assign(__assign({}, VideoModalsMap), ImageModalsMap), GalleryModalsMap), TextColorModalsMap);
export function getPlugins(pluginsConfig, featureFlags) {
    if (pluginsConfig === void 0) { pluginsConfig = defaultPluginsConfig; }
    var plugins = [];
    var extras = {};
    for (var key in pluginsConfig) {
        var pluginConfig = pluginsConfig[key];
        if (key === Plugins.GALLERY && !featureFlags['gallery_settings']) {
            if (Array.isArray(pluginConfig.toolbarButtons)) {
                var tools = pluginConfig === null || pluginConfig === void 0 ? void 0 : pluginConfig.toolbarButtons;
                pluginConfig.toolbarButtons = tools.filter(function (f) { return f !== PluginToolbarButtons.SETTINGS; });
            }
        }
        var pluginCreator = configurablePlugins[key];
        var plugin = pluginCreator(pluginConfig);
        if (plugin.extras) {
            extras = __assign(__assign({}, extras), plugin.extras);
            plugins = __spreadArrays(plugins, [plugin.plugin]);
            continue;
        }
        plugins = __spreadArrays(plugins, [plugin]);
    }
    return { plugins: plugins, extras: extras };
}
//# sourceMappingURL=index.js.map